<template>
    <a-drawer :title="title" width="500" :maskClosable="false" closable :visible.sync="show" @close="() => $emit('update:show', false)" :getContainer="() => $parent.$el">
        <a-form-model ref="form" :model="field" :rules="rules" layout="vertical">
            <!-- <a-form-model-item label="测评咨询师" prop="cta">
                <a-select show-search v-model="field.cta" :filter-option="false" :not-found-content="null" @search="doLoadCta" placeholder="请选择测评咨询师">
                    <a-select-option v-for="item in ctas" :key="item.id" :value="item.id" :label="item.name">
                        {{ item.name }}
                    </a-select-option>
                </a-select>
            </a-form-model-item> -->
            <a-form-model-item label="测评咨询师" prop="cta">
                <a-input v-model="field.cta" placeholder="请填写测评咨询师名称" />
            </a-form-model-item>
            <a-form-model-item label="多动症诊断">
                <a-radio-group v-model="field.other.ddz">
                    <a-radio-button value="Y">
                        阴性
                    </a-radio-button>
                    <a-radio-button value="N">
                        阳性
                    </a-radio-button>
                </a-radio-group>
            </a-form-model-item>
            <a-form-model-item label="感觉统合测评">
                <a-input v-model="field.other.gjth" placeholder="请填写感觉统合测评结果" />
            </a-form-model-item>
            <a-form-model-item label="瑞文智力测评">
                <a-input v-model="field.other.rwzl" placeholder="请填写瑞文智力测评结果" />
            </a-form-model-item>
            <a-form-model-item label="EPQ-儿童测评">
                <a-input v-model="field.other.epqc" placeholder="请填写EPQ-儿童测评结果" />
            </a-form-model-item>
            <a-form-model-item label="EPQ-成人测评">
                <a-input v-model="field.other.epqa" placeholder="请填写EPQ-成人测评结果" />
            </a-form-model-item>
            <a-form-model-item label="SCL-90测评">
                <a-input v-model="field.other.scl90" placeholder="请填写SCL-90测评结果" />
            </a-form-model-item>
            <a-form-model-item label="日常烦恼测评">
                <a-input v-model="field.other.rcfn" placeholder="请填写日常烦恼测评结果" />
            </a-form-model-item>
            <a-form-model-item label="家庭教育方式">
                <a-input v-model="field.other.jtjy" placeholder="请填写家庭教育方式结果" />
            </a-form-model-item>
            <a-form-model-item label="其他事项">
                <a-input v-model="field.other.qt" placeholder="请填写其他事项" />
            </a-form-model-item>

            <a-form-model-item>
                <a-button type="primary" @click="doSave" icon="save">
                    发布报告
                </a-button>
                <a-button style="margin-left: 10px;" icon="redo" @click="doReset">
                    重置
                </a-button>
            </a-form-model-item>
        </a-form-model>
    </a-drawer>
</template>
<script>
export default {
    props: {
        show: {
            type: Boolean,
            required: true
        },
        title: {
            type: String,
            required: true
        },
        item: {
            type: Object,
            required: false,
            default: () => {
                return {}
            }
        }
    },
    data() {
        return {
            ctas: [],
            field: {
                tid: '',
                cta: '',
                other: {
                    ddz: 'N',
                    gjth: '',
                    rwzl: '',
                    epqc: '',
                    epqa: '',
                    rcfn: '',
                    jtjy: '',
                    scl90: '',
                    qt: ''
                },
                drill: []
            },
            rules: {
                tid: [{ required: true, message: '请选择测评信息', trigger: 'blur' }],
                cta: [{ required: true, message: '请选择咨询师', trigger: 'change' }]
            }
        }
    },
    mounted() {
        this.field = {
            tid: this.item.id,
            cta: '',
            other: {
                ddz: 'N',
                gjth: '',
                rwzl: '',
                epqc: '',
                epqa: '',
                rcfn: '',
                jtjy: '',
                scl90: '',
                qt: ''
            },
            drill: []
        }
        this.doLoadCta()
    },
    methods: {
        doLoadCta(name) {
            this.$http
                .get('/sys/data/user/emp', {
                    params: {
                        size: 20,
                        name: name || ''
                    },
                    loading: {
                        full: false
                    }
                })
                .then(result => {
                    this.ctas = result.datas
                })
        },
        doSave() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.field.other = JSON.stringify(this.field.other)
                    this.field.drill = JSON.stringify(this.field.drill)
                    this.$http.post('/cts/ate/testing/mgr/report/create', this.field).then(result => {
                        if (result.code === 0) {
                            this.$emit('doLoad')
                            this.$emit('update:show', false)
                            this.$message.success('发布成功')
                        } else {
                            this.field.other = JSON.parse(this.field.other)
                            this.field.drill = JSON.parse(this.field.drill)
                        }
                    })
                } else {
                    this.$message.error('请填写完整的信息')
                    return false
                }
            })
        },
        doReset() {
            this.$refs.form.resetFields()
            this.$refs.form.clearValidate()
            this.field = {
                tid: this.item.id,
                cta: '',
                other: {
                    ddz: 'N',
                    gjth: '',
                    rwzl: '',
                    epqc: '',
                    epqa: '',
                    rcfn: '',
                    jtjy: '',
                    scl90: '',
                    qt: ''
                },
                drill: []
            }
        }
    }
}
</script>
